import { render } from "./matchHeatmap.vue?vue&type=template&id=0f05ccca&scoped=true"
import script from "./matchHeatmap.vue?vue&type=script&lang=js"
export * from "./matchHeatmap.vue?vue&type=script&lang=js"

import "./matchHeatmap.vue?vue&type=style&index=0&id=0f05ccca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f05ccca"]])

export default __exports__